<template>
  <v-bottom-navigation
    color="white"
    horizontal
    app
    background-color="primary"
  >
    <v-btn 
      :href="url"
      download
    >
      <span>Chat List</span>
      <v-icon>mdi-chat</v-icon>
    </v-btn>
    <v-btn 
      :href="url"
      download
    >
      <span>New Chat</span>
      <v-icon>mdi-chat-plus</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
    export default {
        data () {

        },
        methods: {

        }
    }
</script>

<style lang="sass">
.v-bottom-navigation 
  button 
      span
          color: #fff

  .v-btn
    >.v-btn__content
      color: #fff
      
      .v-icon
        color: #fff
</style>